var map = {
	"./authors/bakir-alt.png": "c456",
	"./authors/bakir.png": "0e2b",
	"./authors/brechtje-alt.png": "6a25",
	"./authors/brechtje.png": "6206",
	"./authors/falco-alt.png": "e430",
	"./authors/falco.png": "7eb8",
	"./authors/janice-alt.png": "248e",
	"./authors/janice.png": "d7a0",
	"./authors/job-alt.png": "96a1",
	"./authors/job.png": "ea12",
	"./authors/jolijn-alt.png": "9e73",
	"./authors/jolijn.png": "d4f5",
	"./authors/jose-alt.png": "8572",
	"./authors/jose.png": "ae24",
	"./authors/klaartje-alt.png": "c24e",
	"./authors/klaartje.png": "e515",
	"./authors/maarten-alt.png": "e935",
	"./authors/maarten.png": "eb4e",
	"./authors/manon-alt.png": "2836",
	"./authors/manon.png": "b7f1",
	"./authors/marcus-alt.png": "7c35",
	"./authors/marcus.png": "4cca",
	"./authors/marieke-alt.png": "a6f9",
	"./authors/marieke.png": "008f",
	"./authors/martine-alt.png": "0ed0",
	"./authors/martine.png": "f799",
	"./authors/ria-alt.png": "5d75",
	"./authors/ria.png": "b0a9",
	"./authors/sandra-alt.png": "e96d",
	"./authors/sandra.png": "4a19",
	"./authors/tim-alt.png": "659f",
	"./authors/tim.png": "4073",
	"./authors/vera-alt.png": "7744",
	"./authors/vera.png": "9f02",
	"./stories/bakir-hero.png": "6914",
	"./stories/janice-hero-alt.png": "bf54",
	"./stories/jose-hero-alt copy.png": "afc0",
	"./stories/jose-hero-alt.png": "e1ba",
	"./stories/jose-hero.png": "32a9",
	"./stories/marcus-hero-alt copy.png": "fc02",
	"./stories/marcus-hero-alt.png": "3138",
	"./stories/marcus-hero.png": "f8ce",
	"./stories/martine-hero-alt.png": "416e",
	"./stories/martine-hero.png": "f682",
	"./stories/sandra-hero.png": "6e61"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2b0f";